/**
 * Generate a consistent gradient class based on a student's name.
 * Uses a simple string hash to deterministically pick from a set of gradients.
 */
export function getAvatarGradient(name: string): string {
  const gradients = [
    'from-indigo-500 to-violet-500',
    'from-emerald-500 to-teal-500',
    'from-amber-500 to-orange-500',
    'from-rose-500 to-pink-500',
    'from-sky-500 to-blue-500',
  ]
  let hash = 0
  for (let i = 0; i < name.length; i++) {
    hash = name.charCodeAt(i) + ((hash << 5) - hash)
  }
  return gradients[Math.abs(hash) % gradients.length]
}
